<div class="container" style="padding: 20px;">
    <div class="row text-center">
        <h1 [innerHTML]="data.title"></h1>
    </div>

    <div class="row justify-content-center text-center">
        <div mat-dialog-content [innerHTML]="data.message">
        </div>
    </div>

    <div *ngIf="data.yesNoButtons" class="row justify-content-center mt-4">
        <div class="col-sm-5">
            <button class="btn btn-primary col-12" (click)="ynSelected(1)">Yes</button>
        </div>
        <div class="col-sm-5">
            <button class="btn btn-primary col-12" (click)="ynSelected(0)">No</button>
        </div>
    </div>

    <div *ngIf="data.okButton" class="row justify-content-center mt-4">
        <div class="col-sm-5">
            <button class="btn btn-primary col-12" (click)="okSelected()">Ok</button>
        </div>
    </div>
</div>